import React from 'react';
import { Breadcrumbs, Link, Typography, Box } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';

const Breadcrumb = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();

  // Define route mappings with their parent categories
  const routeMap = {
    '/dashboard': { name: 'Home', parent: null, color: null },
    '/dashboard/excel-tools': { name: 'Excel Tools', parent: '/dashboard', color: '#228B22' },
    '/dashboard/pdf-tools': { name: 'PDF Tools', parent: '/dashboard', color: '#DC143C' },
    '/dashboard/link-tools': { name: 'Link Tools', parent: '/dashboard', color: '#3B82F6' },
    '/dashboard/other-tools': { name: 'Other Tools', parent: '/dashboard', color: '#FF8C00' },
    '/dashboard/excel-reports': { name: 'Excel Reports', parent: '/dashboard/excel-tools', color: '#228B22' },
    '/dashboard/canadian-13-provinces-freight': { name: 'Canadian 13 Provinces Freight', parent: '/dashboard/excel-tools', color: '#228B22' },
    '/dashboard/eu-freight': { name: 'EU Freight', parent: '/dashboard/excel-tools', color: '#228B22' },
    '/dashboard/pdf-reports': { name: 'PDF Reports', parent: '/dashboard/pdf-tools', color: '#DC143C' },
    '/dashboard/saf1909-inventory-analysis': { name: 'SAF1909 Inventory Analysis', parent: '/dashboard/excel-tools', color: '#228B22' },
    // '/dashboard/inactive-items': { name: 'Inactive Items', parent: '/dashboard/excel-tools', color: '#228B22' }, // DISABLED - Interface hidden
    '/dashboard/excel-export-item-images': { name: 'Excel Export Item Images', parent: '/dashboard/excel-tools', color: '#228B22' },
    // Additional Excel Tools
    '/dashboard/items-detail': { name: 'General Imports', parent: '/dashboard/excel-tools', color: '#228B22' },
    // '/dashboard/design-items-detail': { name: 'Design Items Detail', parent: '/dashboard/excel-tools', color: '#228B22' }, // DISABLED
    // '/dashboard/eu-items-detail': { name: 'EU Items Detail', parent: '/dashboard/excel-tools', color: '#228B22' }, // DISABLED
    '/dashboard/item-image-grouping': { name: 'Item Image Grouping', parent: '/dashboard/excel-tools', color: '#228B22' },
    '/dashboard/po-distribution': { name: 'PO Distribution', parent: '/dashboard/excel-tools', color: '#228B22' },
    '/dashboard/po-distribution-whs': { name: 'PO Distribution WHS', parent: '/dashboard/excel-tools', color: '#228B22' },
    '/dashboard/pallet-optimizer': { name: 'Pallet Optimizer', parent: '/dashboard/other-tools', color: '#FF8C00' },
    '/dashboard/sales-orders-export': { name: 'Sales Orders Export', parent: '/dashboard/excel-tools', color: '#228B22' },
    // '/dashboard/unpublished-items': { name: 'Unpublished Items', parent: '/dashboard/excel-tools', color: '#228B22' }, // DISABLED
    // '/dashboard/us-items-detail': { name: 'US Items Detail', parent: '/dashboard/excel-tools', color: '#228B22' }, // DISABLED
    // '/dashboard/general-imports' is served by '/dashboard/items-detail' route
    '/dashboard/pdf-manipulation': { name: 'PDF Manipulation', parent: '/dashboard/pdf-tools', color: '#DC143C' },
    // Additional PDF Tools
    '/dashboard/ama9999-ucc-labels': { name: 'AMA9999 UCC Labels', parent: '/dashboard/pdf-tools', color: '#DC143C' },
    '/dashboard/amazon-di-ucc-label': { name: 'Amazon DI UCC Label', parent: '/dashboard/pdf-tools', color: '#DC143C' },
    '/dashboard/bilingual-labels': { name: 'Back Labels', parent: '/dashboard/pdf-tools', color: '#DC143C' },
    '/dashboard/carton-labels': { name: 'EU-UCC PDF Modifier - Item', parent: '/dashboard/pdf-tools', color: '#DC143C' },
    '/dashboard/cad-invoices': { name: 'CAD Invoices', parent: '/dashboard/pdf-tools', color: '#DC143C' },
    '/dashboard/expense-allocation-invoices': { name: 'Expense Allocation Invoices', parent: '/dashboard/pdf-tools', color: '#DC143C' },
    '/dashboard/home-goods-pdf': { name: 'Home Goods PDF', parent: '/dashboard/pdf-tools', color: '#DC143C' },
    '/dashboard/pallet-labels': { name: "WAL4000 PDF's", parent: '/dashboard/pdf-tools', color: '#DC143C' },
    '/dashboard/pdq-full-pallet-pull-label': { name: 'PDQ Full Pallet Pull Label', parent: '/dashboard/pdf-tools', color: '#DC143C' },
    '/dashboard/pdf-to-excel-ucc-labels': { name: 'PDF to Excel (UCC Labels)', parent: '/dashboard/pdf-tools', color: '#DC143C' },
    '/dashboard/master-retail-rugs': { name: 'Master Retail Rugs', parent: '/dashboard/pdf-tools', color: '#DC143C' },
    // '/dashboard/product-building': { name: 'Product Building', parent: '/dashboard/excel-tools', color: '#228B22' }, // DISABLED
    '/dashboard/remove-background': { name: 'Remove Background', parent: '/dashboard/other-tools', color: '#FF8C00' },
    '/dashboard/48-state-freight': { name: '48 State Freight', parent: '/dashboard/other-tools', color: '#FF8C00' },
    '/dashboard/reports-scheduler': { name: 'Reports Scheduler', parent: '/dashboard/other-tools', color: '#FF8C00' },
    '/dashboard/view-updates': { name: 'View Updates', parent: '/dashboard', color: null },
    // '/dashboard/furniture-testing': { name: 'Furniture Testing', parent: '/dashboard/other-tools', color: '#FF8C00' }, // DISABLED
    // Additional Other Tools
    '/dashboard/customer-style-search': { name: 'Customer Style Search', parent: '/dashboard/other-tools', color: '#FF8C00' },
    '/dashboard/document-translation': { name: 'Document Translation', parent: '/dashboard/other-tools', color: '#FF8C00' },
    '/dashboard/document-translator': { name: 'Document Translator', parent: '/dashboard/other-tools', color: '#FF8C00' },
    '/dashboard/ftp-transfers': { name: 'FTP Transfers', parent: '/dashboard/other-tools', color: '#FF8C00' },
    // '/dashboard/furniture-regulations': { name: 'Furniture Regulations', parent: '/dashboard/other-tools', color: '#FF8C00' }, // DISABLED
    '/dashboard/marketing-copies': { name: 'Marketing Copies', parent: '/dashboard/other-tools', color: '#FF8C00' },
    // '/dashboard/pallet-configuration': { name: 'Pallet Configuration', parent: '/dashboard/other-tools', color: '#FF8C00' }, // DISABLED
    '/dashboard/product-details': { name: 'Product Details', parent: '/dashboard/other-tools', color: '#FF8C00' },
    '/dashboard/price-scraper': { name: 'Price Scraper', parent: '/dashboard/other-tools', color: '#FF8C00' },
    '/dashboard/social-media-content': { name: 'Social Media Content', parent: '/dashboard/other-tools', color: '#FF8C00' },
    '/dashboard/product-data-validator': { name: 'Product Data Validator', parent: '/dashboard/other-tools', color: '#FF8C00' },
    '/dashboard/email-campaign-builder': { name: 'Email Campaign Builder', parent: '/dashboard/other-tools', color: '#FF8C00' },
    '/dashboard/barcode-generator': { name: 'Barcode / QR Generator', parent: '/dashboard/other-tools', color: '#FF8C00' },
    '/dashboard/ftp-transfer': { name: 'FTP Transfer', parent: '/dashboard/other-tools', color: '#FF8C00' },
    // Add Link Tools specific routes
    '/dashboard/aws-file-links': { name: 'AWS File Links', parent: '/dashboard/link-tools', color: '#3B82F6' },
    // '/dashboard/aws-image-links-jeff': { name: 'AWS Image Links Jeff', parent: '/dashboard/link-tools', color: '#3B82F6' },
    // '/dashboard/jeff-furniture': { name: 'Jeff Furniture', parent: '/dashboard/link-tools', color: '#3B82F6' },
    '/dashboard/aws-file-links-alternate': { name: 'AWS File Links Alternate', parent: '/dashboard/link-tools', color: '#3B82F6' },
    '/dashboard/collection-image-links': { name: 'Collection Image Links', parent: '/dashboard/link-tools', color: '#3B82F6' },
    '/dashboard/wayfair-asset-upload': { name: 'Wayfair Asset Upload', parent: '/dashboard/link-tools', color: '#3B82F6' },
    '/dashboard/amazon-bulk-image-uploader': { name: 'Amazon Bulk Image Uploader', parent: '/dashboard/link-tools', color: '#3B82F6' },
    '/dashboard/broken-link-checker': { name: 'Broken Link Checker', parent: '/dashboard/link-tools', color: '#3B82F6' },
    '/dashboard/image-checker': { name: 'Image Checker', parent: '/dashboard/link-tools', color: '#3B82F6' },
    '/dashboard/bulk-image-downloader': { name: 'Bulk Image Downloader', parent: '/dashboard/link-tools', color: '#3B82F6' },
    '/dashboard/file-converter': { name: 'File Converter', parent: '/dashboard/other-tools', color: '#FF8C00' },
    // AI Tools
    '/dashboard/ai-tools': { name: 'AI Tools', parent: '/dashboard', color: '#722F37' },
    '/dashboard/ai-image-generator': { name: 'AI Image Generator', parent: '/dashboard/ai-tools', color: '#722F37' },
    '/dashboard/ai-video-generator': { name: 'AI Video Generator', parent: '/dashboard/ai-tools', color: '#722F37' },
    '/dashboard/ai-image-search': { name: 'AI Image Search', parent: '/dashboard/ai-tools', color: '#722F37' },
    '/dashboard/rug-room-shots': { name: 'Rug Room Shots', parent: '/dashboard/ai-tools', color: '#722F37' },
    '/dashboard/seo-content-writer': { name: 'SEO Content Writer', parent: '/dashboard/ai-tools', color: '#722F37' },
    '/dashboard/amazon-rug-titles': { name: 'Amazon Rug Titles', parent: '/dashboard/ai-tools', color: '#722F37' },
    // Reports
    '/dashboard/analytics-tools': { name: 'Analytics', parent: '/dashboard', color: '#2FC4B2' },
    '/dashboard/sales-dashboard': { name: 'Sales Dashboard', parent: '/dashboard/analytics-tools', color: '#2FC4B2' },
    '/dashboard/sales-dashboard-v2': { name: 'Sales Dashboard V2', parent: '/dashboard/analytics-tools', color: '#2FC4B2' },
    '/dashboard/returns-dashboard': { name: 'Returns & Quality', parent: '/dashboard/analytics-tools', color: '#2FC4B2' },
    '/dashboard/retail-os': { name: 'RetailOS', parent: '/dashboard/analytics-tools', color: '#2FC4B2' },
    '/dashboard/new-items': { name: 'New Items', parent: '/dashboard/analytics-tools', color: '#2FC4B2' },
    '/dashboard/customer-style-gaps': { name: 'Customer Style Gaps', parent: '/dashboard/analytics-tools', color: '#2FC4B2' },
    '/dashboard/collection-launches': { name: 'Collection Launches', parent: '/dashboard/analytics-tools', color: '#7C4DFF' },
    '/dashboard/sales-pulse': { name: 'Sales Pulse', parent: '/dashboard/analytics-tools', color: '#00897B' },
    '/dashboard/reorder-console': { name: 'Reorder Console', parent: '/dashboard/analytics-tools', color: '#2FC4B2' },
    // Admin
    '/dashboard/admin/users': { name: 'User Management', parent: '/dashboard', color: '#3f51b5' },
    '/dashboard/admin/roles': { name: 'Role Management', parent: '/dashboard', color: '#3f51b5' },
    '/dashboard/admin/file-history': { name: 'File History', parent: '/dashboard', color: '#3f51b5' },
    '/dashboard/admin/notifications': { name: 'Send Notifications', parent: '/dashboard', color: '#3f51b5' },
  };

  // Build breadcrumb path
  const buildBreadcrumbs = () => {
    const currentPath = location.pathname;
    const breadcrumbs = [];
    
    let path = currentPath;
    let categoryColor = null;
    
    // First pass: find the category color from the current path
    let tempPath = currentPath;
    while (tempPath && routeMap[tempPath]) {
      if (routeMap[tempPath].color) {
        categoryColor = routeMap[tempPath].color;
        break;
      }
      tempPath = routeMap[tempPath].parent;
    }
    
    // Second pass: build breadcrumbs with inherited color
    while (path && routeMap[path]) {
      breadcrumbs.unshift({
        path,
        name: routeMap[path].name,
        color: routeMap[path].color || (path !== '/dashboard' ? categoryColor : null)
      });
      path = routeMap[path].parent;
    }

    return breadcrumbs;
  };

  const breadcrumbs = buildBreadcrumbs();

  // Don't show breadcrumbs if we're only on home or if path is not mapped
  if (breadcrumbs.length <= 1) {
    return null;
  }

  return (
    <Box sx={{ mb: 2, px: 3, pt: 2 }}>
      <Breadcrumbs 
        aria-label="breadcrumb" 
        sx={{ 
          '& .MuiBreadcrumbs-separator': {
            color: theme.palette.text.secondary,
          }
        }}
      >
        {breadcrumbs.map((breadcrumb, index) => {
          const isLast = index === breadcrumbs.length - 1;
          
          if (isLast) {
            return (
              <Typography 
                key={breadcrumb.path}
                sx={{ 
                  color: breadcrumb.color || theme.palette.text.primary, 
                  fontWeight: 600 
                }}
              >
                {breadcrumb.name}
              </Typography>
            );
          }
          
          return (
            <Link
              key={breadcrumb.path}
              underline="hover"
              sx={{ 
                color: breadcrumb.color || theme.palette.text.secondary,
                cursor: 'pointer',
                '&:hover': {
                  color: breadcrumb.color || theme.palette.text.primary,
                }
              }}
              onClick={() => navigate(breadcrumb.path)}
            >
              {breadcrumb.name}
            </Link>
          );
        })}
      </Breadcrumbs>
    </Box>
  );
};

export default Breadcrumb;